module.exports = __webpack_public_path__ + "static/sq-0b713fd8fd33a58f28f99b34e540a1c3.png";